import { routes } from '../constants';
import {
  accountingRoutes,
  billingToolRoutes,
  eligibilityRoutes,
  hingeSelectRoutes,
  memberAuthToolRoutes,
  otherRoutes,
  roiRoutes,
  RouteDetails,
} from '../routes';
import { OktaRole } from './okta-roles';

interface RoleDetails {
  showMenu: boolean;
  routes: RouteDetails[];
  postLoginRoute: string;
}

export const roleProperties: Partial<Record<string, RoleDetails>> = {
  [OktaRole.ADJUSTMENT_UPLOAD]: {
    routes: [...accountingRoutes],
    showMenu: true,
    postLoginRoute: routes.accounting,
  },
  [OktaRole.ACCOUNTING_READ]: {
    routes: [...accountingRoutes],
    showMenu: true,
    postLoginRoute: routes.accounting,
  },
  [OktaRole.ACCOUNTING_WRITE]: {
    routes: [...accountingRoutes],
    showMenu: true,
    postLoginRoute: routes.accounting,
  },
  [OktaRole.DELIVERY_OPS]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.REVENUE_CYCLE_MANAGER]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.PHI_MONITORING]: {
    routes: [
      ...roiRoutes,
      ...eligibilityRoutes,
      ...memberAuthToolRoutes,
      ...hingeSelectRoutes,
    ],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.PHI_PRODUCT_MANAGER]: {
    routes: [...roiRoutes],
    showMenu: true,
    postLoginRoute: routes.roi,
  },
  [OktaRole.FINANCE]: {
    routes: [...accountingRoutes],
    showMenu: true,
    postLoginRoute: routes.accounting,
  },
  [OktaRole.HEALTH_ECONOMIST]: {
    routes: [...roiRoutes],
    showMenu: true,
    postLoginRoute: routes.roi,
  },
  [OktaRole.ELIGIBILITY_SELF_SERVICE]: {
    routes: [...eligibilityRoutes],
    showMenu: true,
    postLoginRoute: routes.eligibility,
  },
  [OktaRole.TECHNICAL_SUPPORT]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.MEMBER_SUPPORT]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.TELEPERF_USERS]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.OFFSHORE_SUPPORT]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.ONBOARDING_SPECIALIST]: {
    routes: [...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.member_auth,
  },
  [OktaRole.CLIENT_SUCCESS]: {
    routes: [...roiRoutes, ...eligibilityRoutes, ...memberAuthToolRoutes],
    showMenu: true,
    postLoginRoute: routes.billing_tool,
  },
  [OktaRole.DATA_ANALYST]: {
    routes: [...hingeSelectRoutes],
    showMenu: true,
    postLoginRoute: routes.hinge_select,
  },
  // DO NOT MAKE A CHANGE  ------->>
  [OktaRole.BILLING_READ]: {
    routes: [...billingToolRoutes],
    showMenu: true,
    postLoginRoute: routes.billing_tool,
  },
  [OktaRole.BILLING_WRITE]: {
    routes: [...billingToolRoutes],
    showMenu: true,
    postLoginRoute: routes.billing_tool,
  },
  // <------- DO NOT MAKE A CHANGE
};

export function getRoleProperties(roles: string[] | undefined): RoleDetails {
  const roleResult: RoleDetails = {
    routes: otherRoutes,
    showMenu: false,
    postLoginRoute: routes.other,
  };
  Object.keys(roleProperties).forEach(roleString => {
    const role = roleString as OktaRole;
    const roleDetails = roleProperties[role];
    if (roles?.includes(role) && roleDetails) {
      roleResult.routes = [
        ...new Set([...roleDetails.routes, ...roleResult.routes]),
      ];
      if (roleDetails.showMenu) {
        roleResult.showMenu = true;
      }
      roleResult.postLoginRoute = roleDetails.postLoginRoute;
    }
  });
  return roleResult;
}
